import React from 'react';
import { Button, Flex, useColorModeValue } from '@chakra-ui/react';
import { SearchBar } from '../navbar/searchBar/SearchBar';
import { DateFilter } from '../navbar/dateFilter/DateFilter';
import { useSearch } from '../../contexts/SearchContext';

/**
 * Búsqueda y rango de fechas integrados en el encabezado de la página (no en barra superior global).
 */
const AdminListToolbar = ({ showSearch = false, showDateFilter = false }) => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const toolbarBg = useColorModeValue('gray.50', 'navy.900');
  const { applyFilters, clearFilters } = useSearch();

  if (!showSearch && !showDateFilter) return null;

  return (
    <Flex
      align="center"
      gap={3}
      flexWrap="wrap"
      py={1}
      px={2}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="md"
      bg={toolbarBg}
    >
      {showSearch && (
        <SearchBar
          w={{ base: '100%', sm: '280px' }}
          borderRadius="md"
          background="white"
          placeholder="Nº factura, proveedor o estado…"
        />
      )}
      {showDateFilter && <DateFilter />}
      <Button size="sm" variant="adminSecondary" onClick={clearFilters}>
        Limpiar
      </Button>
      <Button size="sm" variant="adminPrimary" onClick={applyFilters}>
        Aplicar filtros
      </Button>
    </Flex>
  );
};

export default AdminListToolbar;
